import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { fromJS } from "immutable";
import { CornerDownRight, UserCog } from "lucide-react";
import { getConnectionStrength } from "../../api/ItemScoringApi";
import { getItem } from "../../api/ProjectApi";

export const hexToRgba = (hex, alpha = 0.15) => {
  if (!hex) return;
  hex = hex.replace("#", "");
  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

const ConnectionCard = ({ title, itemId }) => {
  const { t } = useTranslation();

  const { data: connectionStrengthData } = useQuery({
    queryKey: ["connection-strength", itemId],
    queryFn: () => getConnectionStrength(itemId),
    enabled: !!itemId,
    staleTime: 60 * 1000, // cache 60s
  });

  const { data: itemData } = useQuery({
    queryKey: ["item", itemId],
    queryFn: () => getItem(itemId),
    enabled: !!itemId,
    staleTime: 60 * 1000, // cache 60s
  });

  const connectionStrength = fromJS(
    connectionStrengthData?.text
      ? connectionStrengthData
      : { strength: 0, text: "No connection", color: "#838282", version: "0" }
  );
  const connectionsCount = fromJS(itemData || {}).getIn(["data", "totalActivities", "value"]) || 0;

  return (
    <div className="rounded-[12px] border border-gray-200 p-2 bg-gray-50 shadow-[0px_1px_1px_0px_rgba(0,0,0,0.05)]">
      <div className="flex items-center gap-1 mb-2">
        <UserCog className="w-4 h-4 text-gray-600" />
        <div className="text-xs font-medium text-gray-600">{title}</div>
      </div>
      <div className="mb-2">
        <div
          className="flex space-x-2 items-center px-2 py-1 text-xs font-medium text-gray-600 w-max rounded-full"
          style={{
            backgroundColor: hexToRgba(connectionStrength.get("color")),
          }}
        >
          <span
            style={{ backgroundColor: connectionStrength.get("color") }}
            className="w-2 h-2 rounded-full"
          ></span>
          <span style={{ color: connectionStrength.get("color") }}>
            {connectionStrength.get("text")}
          </span>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <CornerDownRight className="w-4 h-4 text-gray-600" />
        <div className="text-xs text-gray-600">
          {connectionsCount} {t("connection")}
        </div>
      </div>
    </div>
  );
};

export default ConnectionCard;
